module.exports = __webpack_public_path__ + "assets/e446ad67231efcf87be0a1a45a9f7553.mp3";